import { combineReducers, createStore, compose } from 'redux'
import persistState from 'redux-sessionstorage'
import config from './config'

import {
  smartGuardReducer,
  authReducer,
  programmedGuardReducer,
  loaderReducer,
  errorMessageReducer
} from './reducers'

const rootReducer = combineReducers({
  smartGuard: smartGuardReducer,
  programmedGuard: programmedGuardReducer,
  auth: authReducer,
  loader: loaderReducer,
  errorMessage: errorMessageReducer
})

export const store = createStore(
  rootReducer,
  compose(
    persistState('auth', { key: 'auth' }), // Sync auth state with sessionStorage in browser
    window.__REDUX_DEVTOOLS_EXTENSION__ && config.showDevTools
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  )
)
